import React, { FC, useCallback } from 'react'
import {
  Table,
  TableBody,
  TableCol,
  TableHead,
  TableRow,
} from '@ucheba/ui/components/Table/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { spaceDigits } from '@ucheba/utils/helpers/number'
import dayjs from '@ucheba/utils/helpers/date/dayjs'
import { IStudyOptions } from '../types'

const StudyOptionsCourses: FC<IStudyOptions> = (props) => {
  const { list = [] } = props

  const getDate = useCallback((startAt: string | undefined) => {
    if (startAt) {
      const nowYear = dayjs().format('YYYY')
      const startYear = dayjs().format('YYYY')

      if (nowYear === startYear) {
        return dayjs(startAt).format('D MMM YYYY')
      }

      return dayjs(startAt).format('D MMM')
    }

    return '—'
  }, [])

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCol>Вариант обучения</TableCol>

            <TableCol>Стоимость</TableCol>

            <TableCol>Когда</TableCol>

            <TableCol>Срок обучения</TableCol>

            <TableCol>График занятий</TableCol>
          </TableRow>
        </TableHead>

        <TableBody>
          {list.map((item, key) => {
            const date = (() => {
              const startAt = item.nearestDate?.dateFrom
              const { startType } = item

              if (startType.value === 'date') {
                return getDate(startAt)
              }
              return startType.name
            })()

            return (
              <TableRow key={key}>
                <TableCol verticalAlign='top'>
                  <Text firstLetterUppercase fontWeight='semibold'>
                    {item.trainingFormType.name}
                  </Text>
                </TableCol>

                <TableCol verticalAlign='top'>
                  <Text firstLetterUppercase html={false}>
                    {item.isFree ? (
                      'Бесплатно'
                    ) : (
                      <>{item.price ? `${spaceDigits(item.price)} р.` : '—'}</>
                    )}
                  </Text>
                </TableCol>

                <TableCol verticalAlign='top'>
                  <Text firstLetterUppercase>{date}</Text>
                </TableCol>

                <TableCol verticalAlign='top'>
                  <Text firstLetterUppercase>
                    {item.duration || `${item.academicHours} ак. ч.` || '—'}
                  </Text>

                  {item.academicHours && (
                    <Text firstLetterUppercase fontSize='xsmall1' lineHeight='xsmall1'>
                      {item.duration ? `${item.academicHours} ак. ч.` : ''}
                    </Text>
                  )}
                </TableCol>

                <TableCol verticalAlign='top' width='126px'>
                  <Text firstLetterUppercase>{item.schedule ? item.schedule : '-'}</Text>
                </TableCol>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}

export default StudyOptionsCourses
